import { GET_HOME_CAROUSELS, GET_LAYOUT, GET_RECOMMEND, GET_STATIC_PATHS } from './type'
import moment from 'moment';

// Import cache based on environment
const cache = typeof window === 'undefined'
    ? require('../../utils/cache')
    : require('../../utils/cache').default;

// Cache keys
const CACHE_KEYS = {
    PAGE_LAYOUT: (pageName, date) => `page_layout_${pageName}_${date}`,
    STRAPI_LAYOUT: (pageName, preview) => `strapi_layout_${pageName}_${preview || 'default'}`
};

export function getPageLayout(pageName, d = null) {
    return (dispatch, getState, { axios }) => {
        return new Promise(resolve => {
            const date = d ? d : moment().format("YYYY-MM-DD HH:mm:ss");
            const cacheKey = CACHE_KEYS.PAGE_LAYOUT(pageName, date);

            // Try to get from cache first (if running on server)
            if (typeof window === 'undefined') {
                const cachedData = cache.get(cacheKey);
                if (cachedData) {
                    dispatch({
                        type: GET_LAYOUT,
                        page: pageName,
                        payload: cachedData
                    });
                    return resolve({ components: cachedData });
                }
            }

            axios.post(`/api/web/layout`, {
                pageName,
                date
            })
                .then((response) => {
                    if (response.data.error) {
                        dispatch({
                            type: GET_LAYOUT,
                            page: pageName,
                            payload: []
                        });
                    } else {
                        const components = response.data.components;

                        // Cache the result (if running on server)
                        if (typeof window === 'undefined') {
                            cache.set(cacheKey, components);
                        }

                        dispatch({
                            type: GET_LAYOUT,
                            page: pageName,
                            payload: components
                        });
                    }
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve(error);
                });
        });
    }
}

export function getPageLayoutStrapi(pageName, preview = false) {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            const currentState = getState();
            const currentLayout = currentState.layout.layouts[pageName];
            const cacheKey = CACHE_KEYS.STRAPI_LAYOUT(pageName, preview);

            // Try to get from cache first (if running on server)
            if (typeof window === 'undefined') {
                const cachedData = cache.get(cacheKey);
                if (cachedData) {
                    dispatch({
                        type: GET_LAYOUT,
                        page: pageName,
                        payload: cachedData
                    });
                    return resolve(cachedData);
                }
            }

            // Don't dispatch empty array immediately - let the component handle undefined state
            // This prevents duplicate requests when componentDidUpdate sees the change

            // Add timeout to prevent hanging requests
            const timeoutId = setTimeout(() => {
                console.warn(`Layout request for ${pageName} timed out`);
                resolve([]);
            }, 10000); // 10 second timeout

            axStrapi(preview ? `/page-layouts/${preview}?_publicationState=preview` : `/pages/${pageName}?source=web`)
                .then((response) => {
                    clearTimeout(timeoutId);
                    const content = preview ? response.data.content : response.data.page_layout.content;

                    // Cache the result (if running on server)
                    if (typeof window === 'undefined') {
                        cache.set(cacheKey, content);
                    }

                    dispatch({
                        type: GET_LAYOUT,
                        page: pageName,
                        payload: content,
                        seo: {
                            title: response.data.seo_title,
                            description: response.data.seo_description,
                            keywords: response.data.seo_keywords,
                            og_image: response.data.og_image
                        }
                    });
                    resolve(content);
                })
                .catch((error) => {
                    clearTimeout(timeoutId);
                    console.error(`Failed to load layout for ${pageName}:`, error);

                    // Only dispatch empty array on error if we don't have data
                    if (!currentLayout) {
                        dispatch({
                            type: GET_LAYOUT,
                            page: pageName,
                            payload: []
                        });
                    }
                    resolve([]);
                });
        });
    }
}

export function getRecommendSection(id) {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            // const date = d? d: moment().format("YYYY-MM-DD HH:mm:ss")
            axStrapi.get(`/home-recommend-sections/${id}`)
                .then((response) => {
                    dispatch({
                        type: GET_RECOMMEND,
                        payload: response.data.content
                    });
                    resolve(response.data.content);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_RECOMMEND,
                        payload: []
                    })
                    resolve(error)
                })
        });
    }
}

export function getHomeCarousels() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            axStrapi.get(`/home-carousel-banners`)
                .then((response) => {
                    dispatch({
                        type: GET_HOME_CAROUSELS,
                        payload: response.data
                    });
                    resolve(response.data);
                })
                .catch((error) => {
                    dispatch({
                        type: GET_HOME_CAROUSELS,
                        payload: []
                    })
                    resolve(error)
                })
        })
    }
}

export function getStaticPaths() {
    return (dispatch, getState, { axStrapi }) => {
        return new Promise(resolve => {
            axStrapi.get(`/pages`)
                .then((response) => {
                    dispatch({
                        type: GET_STATIC_PATHS,
                        payload: response.data,
                    })
                    resolve(response.data);
                })
                .catch((error) => {
                    console.log(error);
                    dispatch({
                        type: GET_STATIC_PATHS,
                        payload: [],
                    })
                    resolve([]);
                })
        });
    }
}